import qrcode from 'qrcode-generator';

global.qrcode = qrcode;
